import * as fromResultARActions from '../../../actions/AdmMapa/RedAgua/ResultRA.actions';
import { ResultAR } from 'src/app/models/SicarMap/resultAR.model';


export interface ResultARState {
    result: ResultAR;
}

const initialStateRAR: ResultARState = {
    result : new ResultAR( [], [] )
};

export function resultARReducer(state = initialStateRAR, action: fromResultARActions.RsultARActions): ResultARState {
    switch (action.type) {
        case fromResultARActions.SET_RESULTAR:
            return {
                ...state,
                result: action.Result
            };
      default: {
        return state;
      }
    }
}
